import { toast } from "sonner";
import { deletePartnerByPartnerId } from "./adminApi";

const HEADING = "الشركاء المعتمدون";
const ENHANCED_ATTR = "data-delete-enhanced";

const enhanceVerifiedPartnersTable = () => {
  if (!window.location.pathname.startsWith("/admin")) return;

  const heading = Array.from(document.querySelectorAll("h2")).find(
    (el) => el.textContent?.trim() === HEADING
  );
  if (!heading) return;

  const container = heading.parentElement;
  const table = container?.querySelector("table");
  if (!table) return;

  const headerRow = table.querySelector("thead tr");
  if (headerRow && !headerRow.querySelector(`[${ENHANCED_ATTR}]`)) {
    const th = document.createElement("th");
    th.setAttribute(ENHANCED_ATTR, "true");
    th.className = "text-right px-5 py-3";
    th.textContent = "إجراء";
    headerRow.appendChild(th);
  }

  table.querySelectorAll("tbody tr").forEach((row) => {
    if (row.querySelector(`[${ENHANCED_ATTR}]`)) return;

    const partnerId = row.querySelector("td")?.textContent?.trim();
    if (!partnerId) return;

    const td = document.createElement("td");
    td.setAttribute(ENHANCED_ATTR, "true");
    td.className = "px-5 py-3";

    const button = document.createElement("button");
    button.type = "button";
    button.textContent = "حذف";
    button.className = "inline-flex items-center justify-center px-3 py-1.5 text-xs font-semibold bg-red-600 hover:bg-red-500 text-white disabled:opacity-50";

    button.addEventListener("click", async () => {
      const ok = window.confirm(
        `هل أنت متأكد من حذف الشريك ${partnerId}؟\nسيختفي من لوحة الإدارة ومن الموقع.`
      );
      if (!ok) return;

      button.disabled = true;
      button.textContent = "جارٍ الحذف...";
      try {
        await deletePartnerByPartnerId(partnerId);
        row.remove();
        toast.success(`تم حذف الشريك ${partnerId}`);
      } catch (error) {
        button.disabled = false;
        button.textContent = "حذف";
        const message = error?.response?.data?.detail || "تعذر حذف الشريك";
        toast.error(message);
      }
    });

    td.appendChild(button);
    row.appendChild(td);
  });
};

export const startAdminPartnerDeleteEnhancer = () => {
  let scheduled = false;
  const run = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      enhanceVerifiedPartnersTable();
    });
  };

  const observer = new MutationObserver(run);
  const start = () => {
    observer.observe(document.body, { childList: true, subtree: true });
    run();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
};
